import React from 'react';
import T from 'prop-types';
import classnames from 'classnames';
import Img from '../img/Img';
var ActivityType = function(props) {
    var type = props.type;
    return /*#__PURE__*/ React.createElement("div", {
        className: "ActivityType"
    }, type);
};
ActivityType.propTypes = {
    type: T.string
};
var ActivityDate = function(props) {
    var date = props.date, time = props.time, isLastItem = props.isLastItem, _props_hasPipeSeparator = props.hasPipeSeparator, hasPipeSeparator = _props_hasPipeSeparator === void 0 ? true : _props_hasPipeSeparator;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('ActivityDate', {
            isLastItem: isLastItem,
            removePipeSeparator: !hasPipeSeparator
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: "Date"
    }, date), /*#__PURE__*/ React.createElement("span", {
        className: "Time"
    }, time));
};
ActivityDate.propTypes = {
    date: T.string,
    time: T.string,
    isLastItem: T.bool,
    hasPipeSeparator: T.bool
};
var ActivityCreator = function(props) {
    var name = props.name, image = props.image;
    return /*#__PURE__*/ React.createElement("div", {
        className: "ActivityCreator"
    }, /*#__PURE__*/ React.createElement(Img, {
        img: image
    }), name);
};
ActivityCreator.propTypes = {
    name: T.string,
    image: T.string
};
export var ActivityHeader = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('ActivityHeader', className)
    }, children);
};
ActivityHeader.propTypes = {
    children: T.node,
    className: T.string
};
export var ActivityHeaderElement = function(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('ActivityHeaderElement', className)
    }, children);
};
ActivityHeaderElement.propTypes = {
    children: T.node,
    className: T.string
};
export var HeaderRight = function(param) {
    var classNames = param.classNames, children = param.children;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('HeaderRight', classNames)
    }, children);
};
HeaderRight.propTypes = {
    children: T.node,
    classNames: T.string
};
var ActivityCard = function(props) {
    var children = props.children, className = props.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('ActivityCard', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "Arrow"
    }), children);
};
ActivityCard.propTypes = {
    children: T.node,
    className: T.string
};
ActivityCard.Header = ActivityHeader;
ActivityCard.HeaderRight = HeaderRight;
ActivityCard.HeaderElement = ActivityHeaderElement;
ActivityCard.Date = ActivityDate;
ActivityCard.Type = ActivityType;
ActivityCard.Creator = ActivityCreator;
export default ActivityCard;
